import { render } from "./GraphicsView.vue?vue&type=template&id=2138616e&scoped=true"
import script from "./GraphicsView.vue?vue&type=script&lang=js"
export * from "./GraphicsView.vue?vue&type=script&lang=js"

import "./GraphicsView.vue?vue&type=style&index=0&id=2138616e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2138616e"]])

export default __exports__